import { Button, Dialog, Portal } from '@chakra-ui/react';
import { useRef } from 'react';
import 'dayjs/locale/pl';

type ActionConfirmationDialogProps = {
	isOpen: boolean;
	onClose: () => void;
	onAction: () => void;
	isPending: boolean;
	title: string;
	bodyText: string;
	actionText: string;
	actionColor: string;
};

const ActionConfirmationDialog = ({
	isOpen,
	onClose,
	onAction,
	isPending,
	title,
	bodyText,
	actionText,
	actionColor,
}: ActionConfirmationDialogProps) => {
	const cancelRef = useRef(null);

	return (
        <Dialog.Root
            open={isOpen}
            initialFocusEl={() => cancelRef.current}
            role='alertdialog'
            onOpenChange={e => {
                if (!e.open) {
                    onClose();
                }
            }}>
            <Portal>

                <Dialog.Backdrop>
                    <Dialog.Positioner>
                        <Dialog.Content>
                            <Dialog.Header fontSize="lg" fontWeight="bold">
                                {title}
                            </Dialog.Header>
                            <Dialog.Body>{bodyText}</Dialog.Body>
                            <Dialog.Footer>
                                <Button ref={cancelRef} onClick={onClose}>
                                    Anuluj
                                </Button>
                                <Button
                                    loading={isPending}
                                    colorPalette={actionColor}
                                    onClick={onAction}
                                    ml={3}
                                >
                                    {actionText}
                                </Button>
                            </Dialog.Footer>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Backdrop>

            </Portal>
        </Dialog.Root>
    );
};

export default ActionConfirmationDialog;